import { type } from "os";
import { SaleStatus, SaleType } from "./settlement.model";

export interface CartableNotification {
  cartables: Cartable[];
  totalCount: number;
}
export interface Cartable {
  title: string;
  count: number;
  cartableName: string;
}

export interface GetWorkflowTypesResponse {
  workflowType: string;
  workflowTitle: string;
  state: string;
}
export interface GetCartablesRequest {
  workflowType: string;
}
export interface GetCartablesResponse {
  state: string;
  stateTitle: string;
  count: number;
  status: string;
}
export class GetSupplierSettlementItemsRequest {
  paginationInfo: PaginationInfo | undefined;
  filter: Filter | undefined;
}
export class PaginationInfo {
  pageNumber: number | undefined;
  pageSize?: number = 10;
}
export class Filter {
  state: string | undefined;
  supplierIds?: string[] | undefined;
  supplierName?: string[] | undefined;
  customerNationalCode?: string | undefined;
  rowNumber?: number | undefined;
  // cartablesItemsFilter?:any[];
}
export class FilterNotice {
  state: string | undefined;
  noticeType: string[] | undefined;
  title: string | undefined;
  rowNumber: number | undefined;
}
export class FilterFinder {
  state: string | undefined;
  rowNumber: number | undefined;
  pageNumber: number | undefined;
  // cartablesItemsFilter?:any[];
}
//used in GetAppRegistrationItems
export interface GetSupplierSettlementItemsResponse {
  isInUserCartable: boolean;
  isEditable: boolean;
  loanRequestId: number;
  customerFirstName: string;
  customerLastName: string;
  customerFullName: string;
  customerAddress: string;
  customerPostalCode: string;
  customerNationalCode: string;
  customerMobileNumber: string;
  supplierName: string;
  factorNumber: string;
  requestDate: Date;
  requestDatePersian: string;
  settlementDate: Date;
  settlementDatePersian: string;
  bankApproveDate: Date;
  bankApproveDatePersian: string;
  installmentCount: number;
  installmentAmount: number;
  loanAmount: number;
  profitRate: number;
  loanRequestStatus: string;
  supplierSettlementStatus: string;
  supplierSettlementStatusTitle: string;
  supplierSettlementStatusColor: string;
  loanRequestStatusTitle: string;
  loanRequestStatusColor: string;
  birthDate: Date;
  birthDatePersian: string;
  supplierMobileNumber: string;
  referenceKey: string;
  loanTemplateId: number;
  loanTemplateTitle: string;
  loanRequestSourceTitle: string;
  supplierUserTitle: string;
  supplierUserId: number;
  financialSupplierTitle: string;
  needGuaranteeCheque: boolean;
  needInstallmentCheques: boolean;
  loanRequestSource: string;
  loanRequestStatusUpdateDate: Date;
  stepSpace: number;
  warrantyPercentage: number;
  assigner: string;
}

// this is used in GetAppRegistrationItems for samiin application
export interface GetAppRegistrationItemsResponse {
  entityId: number;
  isInUserCartable: boolean;
  assigner: string;
  referenceKey: string;
  amount: number;
  repaymentType: string;
  repaymentTypeTitle: string;
  stepSpaceByMonth: number;
  durationByMonth: number;
  installmentCount: number;
  durationTitle: string;
  financialSupplier: string;
  financialSupplierTitle: string;
  financialSupplierIconBase64: string;
  loanRequestStatus: string;
  loanRequestStatusTitle: string;
  nationalCode: string;
  customerId: number;
  mobileNumber: string;
  postalCode: string;
  birthDate: string;
  id: number;
  minCreditScoreRequired: number;
  customerFirstName: string;
  customerLastName: string;
  customerFullName: string;
  countOfExtraGuarantors: number;
  fatherName: string;
  shenasnamehNumber: string;
  address: string;
  phoneNumber: string;
  firstInstallmentAmount: number;
  customerFeeAmount: number;
  walletAmount: number;
  customerGuarantyChequeRequired: boolean;
  genderType: "Male" | "Female";
  organizationId: number;
  bankContractUrl: string;
}

export interface GetCartableActionsRequest {
  referenceKey: string;
  workflowType: string;
}

export interface GetCartableActionsResponse {
  stepId: number;
  action: string;
  header: string;
  description: string;
  workflowStepType: string;
  showAsModal: boolean;
  tabs: Tabs[];
}

export interface Tabs {
  title: string;
  inputs: InputsTabs;
}

export interface InputsTabs {
  inputType: string;
  name: string;
  title: string;
  isRequired: boolean;
  data: string;
}
export class DoActionRequest {
  workflowType: string | undefined;
  referenceKey: string | undefined;
  workflowStepType: string | undefined;
  itemId: number | undefined;
  stepId: number | undefined;
  inputs: InputsDoAction[] | undefined;
}

export interface InputsDoAction {
  key: string;
  value: string;
}

export interface DoActionResponse {}
export class ReferenceKey {
  referenceKey: string | undefined;
}
//used in GetAppInformation
export interface GetCoreInformationResponse {
  tabKeys: string[];
  loanRequestInfo: LoanRequestInfo;
  installmentCheques: InfoCheque[];
  guarenteeCheque: InfoCheque;
  contract: DocumentUrl[];
  address: Address;
  identityDocuments: DocumentUrl[];
  factor: Factor;
  incomes: Income[];
  otherDocuments: DocumentUrl[];
  cartableHistory: CartableHistory[];
  supplierCancellationReasons: SupplierCancellationReasons;
  seller: Seller;
  vehicle: Vehicle;
  vehicleExpert: VehicleExpert;
  guarantors: Guarantors[];
  kycInfo: KycInfo;
  bankInfos: BankInfos;
  additionalFieldsInfo: AdditionalFieldsInfo[];
  installments: Installments[];
}

export interface Installments {
  installmentNo: number;
  dueDate_Persian: string;
  amount: number;
  paymentDate_Persian: string;
  paidAmount: number;
}
export interface AdditionalFieldsInfo {
  key: string;
  inputType: string;
  title: string;
  description: string;
  value: string;
}
export interface BankInfos {
  orchestratorToken: string;
  loanInfoItems: {
    title: string;
    value: string;
    url: string | null;
  }[];
  loanInfoActions: LoanInfoActions[];
}

export interface LoanInfoActions {
  title: string;
  command: string;
  description: string;
  role: string;
  isCautionRequired: boolean;
  fields: {
    title: string;
    name: string;
    isRtl: boolean;
  }[];
}
interface SupplierCancellationReasons {
  reasons: string[];
  cancelDate: Date;
  cancelDatePersian: string;
  description: string;
}
export interface CartableHistory {
  workflowType: string;
  workflowTypeTitle: string;
  workflowStepType: string;
  actionDate: string;
  actionDatePersian: string;
  actionTitle: string;
  userTitle: string;
  userData: Userdata[];
}

export interface Userdata {
  key: string;
  value: string;
}
export interface LoanRequestInfo {
  isEditable: boolean;
  loanRequestId: number;
  customerFirstName: string;
  customerLastName: string;
  customerFullName: string;
  customerAddress: string;
  customerPostalCode: string;
  customerNationalCode: string;
  customerMobileNumber: string;
  supplierName: string;
  factorNumber: string;
  requestDate: string;
  requestDatePersian: string;
  settlementDate: string;
  settlementDatePersian: string;
  bankApproveDate: string;
  bankApproveDatePersian: string;
  installmentCount: number;
  installmentAmount: number;
  loanAmount: number;
  profitRate: number;
  loanRequestStatus: string;
  supplierSettlementStatus: string;
  supplierSettlementStatusTitle: string;
  supplierSettlementStatusColor: string;
  loanRequestStatusTitle: string;
  loanRequestStatusColor: string;
  birthDate: string;
  birthDatePersian: string;
  supplierMobileNumber: string;
  referenceKey: string;
  loanTemplateId: number;
  loanTemplateTitle: string;
  loanRequestSourceTitle: string;
  supplierUserTitle: string;
  supplierUserId: number;
  financialSupplierTitle: string;
  needGuaranteeCheque: boolean;
  needInstallmentCheques: boolean;
  loanRequestSource: string;
  loanRequestStatusUpdateDate: string;
  stepSpace: number;
  warrantyPercentage: number;
  registrationRequestId: number;
  minRepaymentPower: number;
  warrantyAmount: number;
  supplierId: number;
  englishFirstName: string;
  englishLastName: string;
  digitallSignRequired: boolean;
  canBeCancelled: boolean;
  organizationTitle: string;
  bankTitle: string;
  repaymentTypeTitle: string;
}

export interface InfoCheque {
  referenceKey: string;
  chequeId: number;
  amount: number;
  amountAlphabet?: string;
  dueDate: string;
  dueDatePersian: string;
  fileId: string;
  rearFileId?: string;
  expectedHolder?: string;
  expectedIdCode?: string;
  chequeType: string;
  sayadNumber: string;
  signer: string;
  idCode: string;
  serialNo: string;
  seriesNo: string;
  fromIban: string;
  branchCode: string;
  bankName: string;
  file: DocumentUrl;
  rearFile: DocumentUrl;
  isAccumulative: boolean;
  accumulativeAmount: number;
  inquiryAmount: number;
  inquiryDueDatePersian: string;
  inquiryDueDate: string;
  reasonTitle: string;
  acceptDate: Date;
  acceptDate_Persian: string;
}

export interface DocumentUrl {
  id: number;
  key?: string | undefined;
  fileId: string;
  fileName: string;
  documentType: string;
  documentTypeTitle: string;
  fileType: string;
  fileUrl: string;
  fileData?: File | undefined;
  thumbnailFileUrl: string;
}

export interface Address {
  id: number;
  personId: number;
  provinceId: number;
  provinceTitle: string;
  cityId: number;
  cityTitle: string;
  postalCode: string;
  addressInfo: string;
  documentUrls: DocumentUrl[];
  addressByInquiry: string;
  phoneNumber: string;
}

export interface Factor {
  factorKey: string;
  factorDate: string;
  factorDate_Persian: string;
  deliveryDate: string;
  deliveryDate_Persian: string;
  factorNumber: string;
  factorFile: DocumentUrl;
  deliveryReceiptFile: DocumentUrl;
  items: Item[];
  factorFileId: string;
  deliveryReceiptFileId: string;
  factorId: number;
  totalPrice: number;
}

export interface Item {
  referenceKey: string;
  factorItemId: number;
  factorKey: string;
  quantity: number;
  title: string;
  unitPrice: number;
  offAmount: number;
  factorItemGroupId: number;
  factorItemGroupTitle: string;
}

export interface Income {
  id: number;
  incomeType: string;
  incomeTypeTitle: string;
  jobTitle: string;
  organizationTitle: string;
  phoneNumber: string;
  address: string;
  amount: number;
  description: string;
  creationDate: string;
  creationDatePersian: string;
  filesUrls: DocumentUrl[];
}

export interface Seller {
  key: string;
  birthDate: Date;
  birthdate_Persian: string;
  nationalCode: string;
  mobileNumber: string;
  postalCode: string;
  addressInquiry: string;
  firstName: string;
  lastName: string;
  fullName: string;
  fatherName: string;
  shenasnamehNumber: string;
  identityDocuments: DocumentUrl[];
}
export interface Vehicle {
  key: string;
  vehicleType: string;
  vehicleTypeTitle: string;
  vin: string;
  pelak: string;
  motorNumber: string;
  model: string;
  productionYear: number;
  kilometer: number;
  color: string;
  description: string;
  insuranceAmount: number;
  insuranceAmountUpdateDate: Date;
  insuranceAmountUpdateUserId: number;
  estimatedPrice: number;
  estimatedPriceUpdateDate: Date;
  estimatedPriceUpdateUserId: number;
  documents: DocumentUrl[];
}
export interface VehicleExpert {
  cityTitle: string;
  nationalCode: string;
  mobileNumber: string;
  firstName: string;
  lastName: string;
  address: string;
  estimatedPrice: number;
  documents: DocumentUrl[];
  isActive: boolean;
  genderType: string;
}
export interface Guarantors {
  isResidenceCompleted: boolean;
  isIncomeCompleted: boolean;
  isIdentityCompleted: boolean;
  isChequeCompleted: boolean;
  key: string;
  birthDate: Date;
  birthdate_Persian: string;
  nationalCode: string;
  mobileNumber: string;
  postalCode: string;
  jobTitle: string;
  monthlyIncome: number | string;
  addressInquiry: string;
  firstName: string;
  lastName: string;
  fullName: string;
  fatherName: string;
  shenasnamehNumber: string;
  idSeri: string;
  idSerial: number;
  genderType: string;
  genderTitle: string;
  identityDocuments: DocumentUrl[];
  residenceDocuments: DocumentUrl[];
  incomeDocuments: DocumentUrl[];
  chequeInfo: InfoCheque;
  reasonTitle: string;
}

export class ErrorsTab {
  errorsHeader: string | undefined;
  errorMessages: string[] | undefined;
}

export interface GetSupplierRequirementItemsRequest {
  paginationInfo: paginationInfo;
  filter: filter;
}

export interface GetSupplierRequirementItemsResponse {
  supplierId: number | undefined;
  title: string | undefined;
  storeTitle: string | undefined;
  isTopRated: boolean | undefined;
  supplierStatus: supplierStatus | undefined;
  supplierStatusTitle: string;
  isInUserCartable: boolean | undefined;
  assigner: string | undefined;
}

type supplierStatus = "Active" | "InActive" | "Suspended";

type paginationInfo = {
  pageNumber: number | undefined;
  pageSize: 10;
};

export type filter = {
  state: string;
  supplierIds?: number[];
  customerNationalCode: string;
};

export interface GetSupplierInformationRequest {
  supplierId: number | undefined;
}

export interface GetSupplierInformationResponse {
  supplierId: number | undefined;
  title: string | undefined;
  storeTitle: string | undefined;
  isTopRated: boolean;
  supplierStatus: supplierStatus;
  supplierStatusTitle: string | undefined;
  supplierCredits: supplierCredits[];
  supplierUsers: supplierUsers[];
}

export interface supplierCredits {
  amount: number;
  creditStatus: creditStatus;
  loanTemplateTitle?: string | undefined;
  creditStatusTitle: string | undefined;
  requestorUserTitle: string | undefined;
  reviewerUserTitle: string | undefined;
  requestDatePersian: string | undefined;
  reviewDatePersian: string | undefined;
}

export interface supplierUsers {
  id: 0;
  firstName: string | undefined;
  lastName: string | undefined;
  isActive: boolean;
  isSuperUser: boolean;
  createDate?: string | undefined;
  createDate_Persian: string | undefined;
  modifyDate?: string | undefined;
  modifyDate_Persian: string | undefined;
  nationalCode: string | undefined;
  mobileNumber: string | undefined;
}

type creditStatus = "WaitForApprove" | "Approved" | "Rejected";

export interface KycInfo {
  kycDate: Date;
  kycDatePersian: string;
  kycStateTitle: string;
  kycText: string;
  kycVideoUrl: string;
  nationalCardFront: NationalCardFront;
}

export interface NationalCardFront {
  id: number;
  key: string;
  fileId: string;
  thumbnailFileId: string;
  fileName: string;
  documentType: string;
  documentTypeTitle: string;
  fileType: string;
  fileUrl: string;
  thumbnailFileUrl: string;
}

export interface GetSaleItemsRequest {
  paginationInfo: PaginationInfo;
  filter: {
    state?: string;
    customerNationalCode?: string;
  };
}

export interface GetSaleItemsResponse {
  id: number;
  referenceKey: string;
  saleDate: string;
  saleDatePersian: string;
  saleType: SaleType;
  saleTypeTitle: string;
  saleStatus: SaleStatus;
  saleStatusTitle: string;
  storeTitle: string;
  branchTitle: string;
  customerNationalCode: string;
  customerFirstName: string;
  customerLastName: string;
  customerFullName: string;
  customerMobileNumber: string;
  totalAmount: number;
  factorNumber: string;
  cashPaymentAmount: number;
  entityId: number;
  isInUserCartable: boolean;
  assigner: string;
}
